(function () {
  function modifyProductInCartInit() {
    const searchParams = new URLSearchParams(window.location.search);
    if (!searchParams.has('modifyProduct')) return;
    
    const keyId = searchParams.get('modifyProduct');
    
    const addToCartBtn = document.querySelector('.cpb-add-to-cart-button');
    if (!addToCartBtn) return;
    
    const span = addToCartBtn.querySelector('span');
    if (span) {
      span.textContent = 'Update Cart';
    }
    
    addToCartBtn.addEventListener('click', function(e) {
      e.preventDefault();
      
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: keyId,
          quantity: 0
        })
      });
    });
  }

  function removeQueryStringParameter(uri, key) {
    if (uri.includes(key) === false) return uri;
    const match = (() => {
      if (uri.includes(`?${key}`))
        return uri.match(new RegExp(`${key}[=]*[^&]*&*`));
      else return uri.match(new RegExp(`&${key}[=]*[^&]*`));
    })();
    return uri.replace(match, "");
  }
  function updateQueryStringParameter(uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|#|$)", "i");
    if (uri.match(re)) {
      return uri.replace(re, "$1" + key + "=" + value + "$2");
    } else {
      var hash = "";
      if (uri.indexOf("#") !== -1) {
        hash = uri.replace(/.*#/, "#");
        uri = uri.replace(/#.*/, "");
      }

      var separator = uri.indexOf("?") !== -1 ? "&" : "?";
      return uri + separator + key + "=" + value + hash;
    }
  }

  function addSaveProgressBtn() {
    const container = document.querySelector(
      ".cpb-product-actions .row:last-child > div"
    );
    if (!container) return;
    if (container.querySelector(".cpb-save-progress")) return;

    const btn = document.createElement("button");
    btn.classList.add("cpb-save-progress", "cpb-actions-btn");
    btn.type = "button";
    btn.textContent = "Save progress";

    const openFormBtn = document.querySelector(".globo-form .floating-button");

    btn.addEventListener("click", async () => {
      openFormBtn?.click();
      let configId = window._cpb.saveConfig(null, false);
      if (configId instanceof Promise) configId = await configId;

      const baseUrl = removeQueryStringParameter(
        location.href,
        "modifyProduct"
      );
      const configUrl = updateQueryStringParameter(
        baseUrl,
        "configid",
        configId
      );

      setTimeout(() => {
        const input = document.querySelector(
          '.globo-form-control.productUrl input'
        );
        if (input) input.value = configUrl;
      }, 0);
    });

    container.appendChild(btn);
  }

  document.body.addEventListener("CPB_ON_PRODUCT_MOUNTED", function (event) {
    addSaveProgressBtn();
    modifyProductInCartInit();
  });
})();
